EG.Users.Profile.Analytics.selfRegistrationViaCompany = {
  PAGE_NAME: EG.Users.Profile.Analytics.PAGE_NAME + EG.Users.Analytics.separator + 'SelfRegistrationCompanyWide',
  NAME: 'Users.Profile' + EG.Users.Analytics.separator + 'SelfRegistrationCompanyWide'
};

EG.Users.Profile.Analytics.selfRegistrationViaCompany = _.extend(
  EG.Users.Profile.Analytics.selfRegistrationViaCompany,
  {
    VIEW: EG.Users.Profile.Analytics.selfRegistrationViaCompany.NAME + EG.Users.Analytics.separator + 'Viewed',
    SUBMIT: EG.Users.Profile.Analytics.selfRegistrationViaCompany.NAME + EG.Users.Analytics.separator + 'Submited',
    REGIONAL_NAME_CREATED:
      EG.Users.Profile.Analytics.selfRegistrationViaCompany.NAME + EG.Users.Analytics.separator + 'RegionalName.created',
    COMPANY_GENERATED:
      EG.Users.Profile.Analytics.selfRegistrationViaCompany.NAME + EG.Users.Analytics.separator + 'CompanyLink.generated',
    CAPTCHA_DISPLAYED:
      EG.Users.Profile.Analytics.selfRegistrationViaCompany.NAME + EG.Users.Analytics.separator + 'TextCaptcha.displayed',
    REFRESH_AUDIO_CAPTCHA:
      EG.Users.Profile.Analytics.selfRegistrationViaCompany.NAME + EG.Users.Analytics.separator + 'AudioCaptcha.refreshed',
    REFRESH_CAPTCHA:
      EG.Users.Profile.Analytics.selfRegistrationViaCompany.NAME + EG.Users.Analytics.separator + 'TextCaptcha.refreshed',
    REPLAY_AUDIO_CAPTCHA:
      EG.Users.Profile.Analytics.selfRegistrationViaCompany.NAME + EG.Users.Analytics.separator +  'AudioCaptcha.replayed',
    CAPTCHA_MODE_CHANGED:
      EG.Users.Profile.Analytics.selfRegistrationViaCompany.NAME + EG.Users.Analytics.separator +  'CaptchaMode.changed',
    INCORRECT_CAPTCHA_ENTERED:
      EG.Users.Profile.Analytics.selfRegistrationViaCompany.NAME + EG.Users.Analytics.separator +  'IncorrectCaptcha.entered'
  }
);

EG.Users.Profile.Analytics.selfRegistrationViaCompany.guest = {
    PAGE_NAME: EG.Users.Analytics.pagePrefix + EG.Users.Analytics.separator + 'Users' + EG.Users.Analytics.separator + 'SelfRegistration' + EG.Users.Analytics.separator + 'guest' + EG.Users.Analytics.separator + 'link',
    NAME: 'Users' + EG.Users.Analytics.separator + 'SelfRegistration' + EG.Users.Analytics.separator + 'guest' + EG.Users.Analytics.separator + 'link'
};

EG.Users.Profile.Analytics.selfRegistrationViaCompany.guest = _.extend(
    EG.Users.Profile.Analytics.selfRegistrationViaCompany.guest,
    {
        VIEW: EG.Users.Profile.Analytics.selfRegistrationViaCompany.guest.NAME + EG.Users.Analytics.separator + 'Viewed',
        SUBMIT: EG.Users.Profile.Analytics.selfRegistrationViaCompany.guest.NAME + EG.Users.Analytics.separator + 'Submited',
        REGIONAL_NAME_CREATED:
            EG.Users.Profile.Analytics.selfRegistrationViaCompany.guest.NAME + EG.Users.Analytics.separator + 'RegionalName' + EG.Users.Analytics.separator + 'created',
        COMPANY_GENERATED:
            EG.Users.Profile.Analytics.selfRegistrationViaCompany.guest.NAME + EG.Users.Analytics.separator + 'CompanyLink' + EG.Users.Analytics.separator + 'generated',
        CAPTCHA_DISPLAYED:
            EG.Users.Profile.Analytics.selfRegistrationViaCompany.guest.NAME + EG.Users.Analytics.separator + 'TextCaptcha' + EG.Users.Analytics.separator + 'displayed',
        REFRESH_AUDIO_CAPTCHA:
            EG.Users.Profile.Analytics.selfRegistrationViaCompany.guest.NAME + EG.Users.Analytics.separator + 'AudioCaptcha' + EG.Users.Analytics.separator + 'refreshed',
        REFRESH_CAPTCHA:
            EG.Users.Profile.Analytics.selfRegistrationViaCompany.guest.NAME + EG.Users.Analytics.separator + 'TextCaptcha' + EG.Users.Analytics.separator + 'refreshed',
        REPLAY_AUDIO_CAPTCHA:
            EG.Users.Profile.Analytics.selfRegistrationViaCompany.guest.NAME + EG.Users.Analytics.separator + 'AudioCaptcha' + EG.Users.Analytics.separator + 'replayed',
        CAPTCHA_MODE_CHANGED:
            EG.Users.Profile.Analytics.selfRegistrationViaCompany.guest.NAME + EG.Users.Analytics.separator + 'CaptchaMode' + EG.Users.Analytics.separator + 'changed',
        INCORRECT_CAPTCHA_ENTERED:
            EG.Users.Profile.Analytics.selfRegistrationViaCompany.guest.NAME + EG.Users.Analytics.separator + 'IncorrectCaptcha' + EG.Users.Analytics.separator + 'entered'
    }
);
